// AnnotationSession.js — Typed bridge between figure node views and AnnotationEditorPortal.
// Mirrors MapSession.js exactly. Carries the PM EditorView getter for Comment/Reference actions.

/**
 * @typedef {{
 *   blockId: string,
 *   src: string,
 *   getView: (() => import('prosemirror-view').EditorView | null) | null,
 *   currentUser: ({ uid?: string, id?: string } | null),
 * }} AnnotationEditorSessionRequest
 */

/** @type {Set<(request: AnnotationEditorSessionRequest) => void>} */
const listeners = new Set();

/**
 * Open the annotation editor for a figure.
 * @param {AnnotationEditorSessionRequest} request
 */
export function openAnnotationEditor(request) {
    if (!request?.blockId) return;
    listeners.forEach((fn) => {
        try {
            fn(request);
        } catch (err) {
            console.warn('[AnnotationSession] listener failed', err);
        }
    });
}

/**
 * Subscribe to annotation editor open requests.
 * @param {(request: AnnotationEditorSessionRequest) => void} listener
 * @returns {() => void} unsubscribe function
 */
export function subscribeAnnotationOpen(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
